module.exports = __webpack_public_path__ + "static/media/iPod Touch.812499ac.jpg";